export class SurveyActivityModel {
    constructor({ event, createdAt, properties }) {
        this.event = event;
        this.createdAt = createdAt;
        // Properties
        this.name = properties.name;
        this.age = properties.age;
        this.city = properties.city;
        this.code = properties.code;
        this.email = properties.email;
        this.gender = properties.gender;
        this.interest = properties.interest;
        this.profilePic = properties.profilePic;
        this.region = properties.region;
        this.appId = properties.appId;
        this.countryCode = properties.countryCode;
        this.mobileNo = properties.mobileNo;
    }
    get defaultCountryCode() {
        return '+63';
    }
    get completeMobileNumber() {
        const code = this.countryCode || this.defaultCountryCode;
        return `${code} ${this.mobileNo}`;
    }
}
